<template>
  <div class="office">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'代表处管理'}]"></breadcrumb>
    <div class="office-wrap">
      <div class="office-contain">
        <user-top-nav>
          <el-button @click="addOffice()" type="primary">
            <font-awesome-icon :icon="['fas', 'plus']"/>
            <span style="margin-left:5px; font-size:14px;">创建代表处</span>
          </el-button>
        </user-top-nav>
        <div class="office-list-wrap">
          <div
            v-for="(item,index) in officeList"
            :key="item.id"
            class="office-item"
            @click="editOffice(index)"
          >
            <div class="office-item_icon">
              <font-awesome-icon :icon="['fas', 'flag']" size="4x"/>
            </div>
            <div class="office-item_name">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="336px" class="role-dialog" title="新建代表处" :visible.sync="officeFormVisible">
      <el-form label-position="top" :model="officeForm">
        <el-form-item label="代表处名称">
          <el-input v-model="officeForm.representOffice.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="选择省">
          <el-select v-model="officeForm.areaCodeList" multiple placeholder="请选择">
            <el-option
              v-for="item in areaList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()">提 交</el-button>
        <el-button @click="officeFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/servies/axios";
import api from "@/servies/api";
import breadcrumb from "@/components/breadcrumb";
import userTopNav from "@/components/userTopNav";
export default {
  components: {
    breadcrumb,
    userTopNav
  },
  data() {
    return {
        areaList:[],
      officeList: [],
      officeFormVisible: false,
      officeForm: {}
    };
  },
  created() {
    this.initForm();
    this.getAreaList();
    this.getOfficeList();
  },
  methods: {
    //表单清空
    initForm() {
      this.officeForm = {
        representOffice: { name: "" },
        areaCodeList: []
      };
    },
    getAreaList() {
      axios
        .post(api.areaList)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取所有行政区列表成功", res.data.result);
            this.areaList = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    getOfficeList() {
      axios
        .get(api.repOfficeList)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取代表处列表成功", res.data.result);
            this.officeList = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    addOffice() {
      this.initForm()
      this.officeFormVisible = true;
    },
    editOffice(index) {
        axios
        .get(api.getAreaList + `?representId=${this.officeList[index].id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取行政区列表成功", res.data.result);
            this.officeForm.areaCodeList = res.data.result.map(item => {
                return item.id
            })
            if (!this.showForm) {
              this.showForm = true;
            }
          } else {
            console.log("获取行政区列表成功", res.data.msg);
          }
        })
        .catch(error => {
          console.log("获取行政区列表失败", error);
        });
      this.officeForm.representOffice = this.officeList[index]
      this.officeFormVisible = true
    },
    submit() {
      let params = {
        isAdd: !this.officeForm.representOffice.id,
        areaCodeList: this.officeForm.areaCodeList,
        representOffice: this.officeForm.representOffice
      };
      console.log(params);
      axios
        .post(api.addOrUpdateRepOffice, params)
        .then(res => {
          if (res.data.code === 0) {
            this.officeFormVisible = false;
            this.$message({
              message: "创建代表处成功",
              type: "success"
            });
            this.getOfficeList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    }
  }
};
</script>

<style lang="scss">
.office {
  .office-wrap {
    padding: 77px 30px 0px 30px;
    .office-contain {
      border-radius: 4px;
      background: #fff;
      border: 1px solid rgba(230, 227, 227, 1);
      .office-list-wrap {
        padding: 48px;
        min-height: 470px;
        padding-right: 0px;
        display: flex;
        flex-wrap: wrap;
        .office-item {
          cursor: pointer;
          margin-right: 40px;
          margin-bottom: 40px;
          height: 150px;
          width: 150px;
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #dcdfe6;
          flex-direction: column;
          &:hover {
            background: rgba(255, 240, 231, 1);
            color: #f0722b;
            .office-item_name {
              color: #f0722b;
            }
          }
          .office-item_name {
            margin-top: 8px;
            color: #4a4a4a;
          }
        }
      }
    }
  }
}
.role-dialog {
  .el-form-item {
    margin-bottom: 0px;
    .el-select{
        width: 296px;
    }
    .el-form-item__label {
      margin-top: 33px;
      font-size: 14px;
      line-height: 20px;
      color: #4a4a4a;
    }
  }
  .el-dialog__header {
    color: #4a4a4a;
    font-weight: 600;
    font-size: 18px;
  }
  .el-dialog__body {
    padding-top: 6px;
    padding-bottom: 0px;
  }
  .el-dialog__footer {
    //padding-top: 0px;
    text-align: left;
    .el-button {
      width: 88px;
    }
  }
}
</style>